<template>
  <div>
    <p v-if="message !== null">
      {{ message }}
    </p>

    <player-regattas-table
      v-if="isRegattasTableVisible"
      :playerId="playerId"
      :regattas="regattas"
    />

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';
import notifier from '../../notifier.js';

import LoadingIndicator   from '../LoadingIndicator.vue';
import PlayerRegattasTable from './PlayerRegattasTable.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'PlayerRegattas',

  components: {
    LoadingIndicator,
    PlayerRegattasTable,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,
      regattas: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      const regattas = this.regattas;
      if(regattas !== null && regattas.length === 0) {
        return 'У этого игрока нет регат.';
      }

      return null;
    },

    /** @returns {boolean} */
    isRegattasTableVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const regattas = this.regattas;
      return (regattas !== null) && (regattas.length > 0);
    },
  },

  created() {
    this.loadPlayerRegattas();
  },

  methods: {
    loadPlayerRegattas() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = '/player/' + this.playerId + '/regattas';
      HTTP.get(url)
      .then(response => {
        this.regattas = response.data.data;
        //this.regattas = getTestRegattas();
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
}

/*
function getTestRegattas() {
  const testRegattas = [
    {
      "regatta": {
        "id": 663,
        "start_at": 1733464800,
        "finish_at": 1733724000,
        "actual_start_at": 1733464815,
        "actual_finish_at": 1733724012,
        "min_version": 95000100,
        "status": 1,
        "created_at": 1706714761,
        "audience": 0,
        "ab_test_id": 0,
        "ab_test_group": ""
      },
      "joinTime": 1733499248,
      "roundAmount": 2
    },
    {
      "regatta": {
        "id": 662,
        "start_at": 1732255200,
        "finish_at": 1732514400,
        "actual_start_at": 1732255211,
        "actual_finish_at": 1732514422,
        "min_version": 95000100,
        "status": 2,
        "created_at": 1706714761,
        "audience": 0,
        "ab_test_id": 0,
        "ab_test_group": ""
      },
      "joinTime": 1732341327,
      "roundAmount": 4
    }
  ];

  return testRegattas;
}
*/
</script>
